import axios, {AxiosPromise, AxiosRequestConfig, AxiosResponse} from 'axios'
import {notify} from "@kyvg/vue3-notification";
import {stockApi} from "@/api/stock-api";
import {symbolApi} from "@/api/symbol-api";
import userApi from "@/api/user-api";

axios.defaults.withCredentials = true;
axios.interceptors.response.use(
    (res: AxiosResponse) => {
        return res;
    },
  (error: any) => {
        console.log("error--->", error)
        if (error.response?.status === 404) {
            notify({type: 'error', text: '404 not found'})
        }
        if (error.response?.status === 500) {
            notify({type: 'error', text: '服务器错误'})
        }
      if (error.response?.status === 401){
          const isMobile = window.innerWidth < 768
          if (isMobile){
              window.location.href = '/#/login'
          }else{
              window.location.href = '/#/mobile_home'
          }


          notify({
              type:'warn',
              text:'登录已失效'
          })
      }
      return Promise.reject(error)
    }
);

const APIUri = {
    BaseUri: '/api/v1',
    stock: stockApi,
    user: userApi,
    symbol: symbolApi,
}

axios.defaults.baseURL = APIUri.BaseUri;
export {APIUri}

type APIResult = {
    code: number,
    msg: string,
    count: number,
    data: any[]
}
export const post = (uri: string, data: any, config?: AxiosRequestConfig): AxiosPromise => {
    return axios.post(uri, data, config)
}
export const list = (uri: string, params: any,  config?: AxiosRequestConfig): AxiosPromise => {
    return axios.get<APIResult>(uri, {params: params, ...config})
}
export const get = (uri: string, id: number, config?: AxiosRequestConfig): AxiosPromise => {
    return axios.get<APIResult>(uri, {params: { id: id }, ...config})
}
export const create = (uri: string, data: any): AxiosPromise => {
    return axios.post(uri, data)
}
export const update = (uri: string, data: any): AxiosPromise => {
    return axios.put<APIResult>(uri, data)
}
export const del = (uri: string, id: number | string): AxiosPromise => {
    return axios.delete<APIResult>(uri, {params: { id: id }})
}
